import { createTheme } from "@mui/material/styles";

export const appColors = {
  brand: {
    primary: "#19438C",
    primaryDark: "#12356F",
    accent: "#AD8401",
  },
  neutral: {
    black: "#000000",
    white: "#FFFFFF",
    gray50: "#F8F8F8",
    gray700: "#455A64",
  },
  feedback: {
    error: "#D32F2F",
    warning: "#ED6C02",
    success: "#2E7D32",
    info: "#0288D1",
  },
};

class ThemeService {
  static get colors() {
    return appColors;
  }

  static theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: appColors.brand.primary,
        dark: appColors.brand.primaryDark,
        contrastText: appColors.neutral.white,
      },
      secondary: {
        main: appColors.brand.accent,
      },
      error: {
        main: appColors.feedback.error,
      },
      warning: {
        main: appColors.feedback.warning,
      },
      success: {
        main: appColors.feedback.success,
      },
      info: {
        main: appColors.feedback.info,
      },
      background: {
        default: appColors.neutral.gray50,
        paper: appColors.neutral.white,
      },
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: appColors.neutral.gray50,
            color: appColors.neutral.black,
            boxSizing: "border-box",
          },
        },
      },
    },
  });
}

export default ThemeService;
